<template>
  <RouterView />
</template>

<script>
export default {
  data () {
    return {
      breadcrumb: {
        name: new Promise(resolve => {
          this
            .$sdk
            .account
            .read(this.$route.params.accountId)
            .then(account => resolve(account.name))
        }),
        route: { name: 'sales-opportunities-account', params: { accountId: this.$route.params.accountId } }
      },
      sidebar: [
        {
          icon: ['fal', 'tasks'],
          route: { name: 'sales-opportunities-account-todo', params: { accountId: this.$route.params.accountId } },
          name: 'To-Do'
        },
        {
          icon: ['fal', 'cogs'],
          route: { name: 'sales-opportunities-account-configure', params: { accountId: this.$route.params.accountId } },
          name: 'Configure'
        },
        {
          icon: ['fal', 'address-book'],
          route: { name: 'sales-opportunities-account-contacts', params: { accountId: this.$route.params.accountId } },
          name: 'Contacts'
        },
        {
          icon: ['fal', 'paperclip'],
          route: { name: 'sales-opportunities-account-attachments', params: { accountId: this.$route.params.accountId } },
          name: 'Attachments'
        },
        {
          icon: ['fal', 'comment-alt'],
          route: { name: 'sales-opportunities-account-notes', params: { accountId: this.$route.params.accountId } },
          name: 'Notes'
        }
      ]
    }
  }
}
</script>
